export const SET_CONTACT_US_RESULT = 'SET_CONTACT_US_RESULT';